<script>
export default {}
</script>

<template>
  <div :class="$style.formGroup">
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

$line-margin: 10px;

.formGroup {
  display: flex;
  flex-wrap: wrap;

  > * {
    flex: 1 1;
    min-width: 200px;
    margin-right: 30px;
  }
}
</style>
